var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOtherImage = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.78141 5.54473C5.84639 5.60987 5.84629 5.71534 5.78119 5.78036C5.71609 5.84538 5.61062 5.84534 5.54556 5.78029C5.4805 5.71523 5.48047 5.60976 5.54549 5.54466C5.6105 5.47956 5.71597 5.47946 5.78111 5.54443L5.78141 5.54473",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9961 6.73707C11.9919 6.42898 9.96076 7.09405 8.52692 8.52789C7.09307 9.96174 6.42801 11.9928 6.73609 13.9971",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6628 1.99609H5.32943C3.48848 1.99609 1.99609 3.48848 1.99609 5.32943V10.6628C1.99609 12.5037 3.48848 13.9961 5.32943 13.9961H10.6628C12.5037 13.9961 13.9961 12.5037 13.9961 10.6628V5.32943C13.9961 3.48848 12.5037 1.99609 10.6628 1.99609Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOtherImage);
export default ForwardRef;